import { Wheel } from './wheel';
import {
  WheelParameters,
  ViewParameters,
  DEFAULT_WHEEL_PARAMETERS,
  DEFAULT_VIEW_PARAMETERS,
} from './parameters';

declare global {
  interface Window {
    spokeCalc: State;
    umami?: {
      track: (eventName: string, eventProps?: Record<string, unknown>) => void;
    };
  }
}

export interface State {
  selectedId?: string;
  wheel?: Wheel;
  wheelParameters: WheelParameters;
  viewParameters: ViewParameters;
  refresh: (recalculate?: boolean) => void;
  select: (id: string | undefined) => void;
  animationId?: number;
}

export const getState = (): State => {
  if (!window.spokeCalc) {
    window.spokeCalc = {
      selectedId: undefined,
      wheelParameters: DEFAULT_WHEEL_PARAMETERS,
      viewParameters: DEFAULT_VIEW_PARAMETERS,
      wheel: undefined,
      refresh: () => {},
      select: (id: string | undefined) => {
        const state = getState();
        state.selectedId = id;
        state.refresh();
      },
    };
  }
  return window.spokeCalc;
};
